import styled from "styled-components";

export const AppMain = styled.main`
  max-width: ${(p) => p.theme.maxWidth};
  margin: 28px auto;
  padding: 0 12px;
  display: flex;
  flex-direction: column;
  gap: ${(p) => p.theme.gap};
  width: 100%;

  @media (min-width: 420px) {
    padding: 0 16px;
    margin: 32px auto;
  }
  @media (min-width: 900px) {
    padding: 0 20px;
    margin: 36px auto;
  }
`;

export const Card = styled.div`
  background: ${(p) => p.theme.colors.card};
  border-radius: ${(p) => p.theme.radius};
  box-shadow: 0 6px 20px rgba(3, 10, 18, 0.06);
  padding: 18px;
`;

export const Section = styled.section`
  padding: 18px 0;
  width: 100%;
`;

export const H2 = styled.h2`
  margin: 0 0 8px 0;
  font-size: 1.25rem;
  @media (min-width: 900px) {
    font-size: 1.5rem;
  }
`;
